"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TourContext_1 = require("context/TourContext");
const HelperUtils_1 = require("utils/HelperUtils");
const useGeneratePosition_1 = __importDefault(require("./useGeneratePosition"));
function useElementChecking({ targetQuerySelector, forcedCloseQuerySelector, timeout, waitElement, scrollToElement }) {
    const [isVisible, setVisibility] = (0, react_1.useState)(false);
    const { clearTour } = (0, TourContext_1.useTourContext)();
    const showElement = (targetElement, timeoutValue) => {
        setTimeout(() => {
            scrollToElement && targetElement.scrollIntoView();
            setVisibility(true);
        }, timeoutValue);
    };
    const forcedStop = () => {
        setVisibility(false);
        clearTour();
    };
    (0, react_1.useEffect)(() => {
        setVisibility(false);
        const containerEl = document.querySelector('body');
        const targetElement = document.querySelector(targetQuerySelector);
        const timeoutValue = timeout || 0;
        if (targetElement) {
            showElement(targetElement, timeoutValue);
            return () => setVisibility(false);
        }
        if (!containerEl || !waitElement)
            return;
        const observer = new MutationObserver((mutationList) => {
            mutationList.forEach(function (mutation) {
                if (mutation.type != 'childList')
                    return;
                const targetElement = document.querySelector(targetQuerySelector);
                if (!targetElement)
                    return;
                let stopComponent = null;
                if (forcedCloseQuerySelector) {
                    stopComponent = document.querySelector(forcedCloseQuerySelector);
                }
                if (stopComponent) {
                    forcedStop();
                    observer.disconnect();
                    return;
                }
                showElement(targetElement, timeoutValue);
                observer.disconnect();
            });
        });
        observer.observe(containerEl, { childList: true, subtree: true });
        return () => {
            observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        targetQuerySelector,
        forcedCloseQuerySelector,
        scrollToElement,
        timeout,
        waitElement
    ]);
    return isVisible;
}
const TourComponentWrapper = (props) => {
    const isVisible = useElementChecking({
        targetQuerySelector: props.targetQuerySelector,
        forcedCloseQuerySelector: props.forcedCloseQuerySelector,
        timeout: props.timeout,
        scrollToElement: props.scrollToElement,
        waitElement: props.waitElement
    });
    if (!isVisible)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return react_1.default.createElement(TourComponent, null);
};
const TourComponent = () => {
    const { nextStep, currentStepData, clearTour, tourData, isLastStep } = (0, TourContext_1.useTourContext)();
    const { title, content, onNext, targetQuerySelector, borderMargin, position: fromBubblePosition, borderedTarget, borderColor, CustomComponent, onSkip } = currentStepData || {};
    const { skippable } = tourData || {};
    const { bubbleRef, containerRef, position, setPosition } = (0, useGeneratePosition_1.default)({
        targetQuerySelector,
        borderMargin,
        fromBubblePosition,
        borderedTarget,
        borderColor
    });
    const nextHandler = () => {
        nextStep();
        onNext && onNext();
        setPosition(null);
    };
    const skipHandler = () => {
        clearTour();
        onSkip && onSkip();
    };
    return (react_1.default.createElement("div", { ref: containerRef, className: "w-[100vw] h-[100vh] fixed top-[0] left-[0] z-[10002]", onClick: (e) => e.stopPropagation() },
        react_1.default.createElement("div", { ref: bubbleRef, className: `absolute ${!position ? 'invisible' : ''}`, style: { top: (position === null || position === void 0 ? void 0 : position.top) + 'px', left: (position === null || position === void 0 ? void 0 : position.left) + 'px' } }, CustomComponent ? (react_1.default.createElement(CustomComponent, { title: title, content: content, onNext: nextHandler, onSkip: skipHandler })) : (react_1.default.createElement("div", { className: "bg-base-700 p-[24px] shadow-raised rounded-[8px] w-[400px] " },
            react_1.default.createElement("p", { className: "typography-h700 text-n-000" }, title),
            react_1.default.createElement("p", { className: "typography-h500 text-n-000 mt-[24px]" }, content),
            react_1.default.createElement("div", { className: "flex flex-row items-center justify-between mt-[28px]" },
                react_1.default.createElement("div", { className: "" }, skippable && !isLastStep && (react_1.default.createElement("p", { className: "typography-button text-n-000 cursor-pointer", onClick: skipHandler }, (0, HelperUtils_1.getObjectiveLocale)('Skip this tutorial')))),
                react_1.default.createElement("div", { className: "rounded bg-base-600 px-[16px] py-[8px] cursor-pointer", onClick: nextHandler },
                    react_1.default.createElement("p", { className: "text-n-100 typography-button" }, (0, HelperUtils_1.getObjectiveLocale)('Next')))))))));
};
exports.default = TourComponentWrapper;
